import React from 'react';
import { Product } from 'bootstrap/data/product/Product';
import Perfectionist from 'assets/livenicons/perfectionist.svg';
import Goal from 'assets/livenicons/goal.svg';

import { PlanSelectType } from 'subscription/singleproduct/components/plansection/PlanSection.constants';
import styles from './styles.module.scss';

type Props = {
  product: Product;
  planType?: PlanSelectType;
  handleGetPlanClick: () => void;
  children: JSX.Element[] | JSX.Element;
};

export const PlanSectionWrapper = ({ children, handleGetPlanClick }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.checkoutPriceResults}>
        <div className={`${styles.result} ${styles.divider}`}>
          <img src={Perfectionist} alt="" />
          <div className={styles.resultContent}>
            <p className={styles.title}>Main difficulty</p>
            <p className={styles.description}>Perfectionist</p>
          </div>
        </div>

        <div className={styles.result}>
          <img src={Goal} alt="" />
          <div className={styles.resultContent}>
            <p className={styles.title}>Goal</p>
            <p className={styles.description}>Focus levels</p>
          </div>
        </div>
      </div>

      {children}

      <button className={styles.submit} onClick={handleGetPlanClick}>
        GET MY PLAN
      </button>
    </div>
  );
};
